import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import axios from 'axios';

function AdminLogin() {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [token, setToken] = useState(localStorage.getItem('admin_token'));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/auth/admin-login', { username, password });
      localStorage.setItem('admin_token', response.data.token);
      localStorage.setItem('admin_user', JSON.stringify(response.data.admin || {}));
      setToken(response.data.token);
      navigate('/yonetim/panel');
    } catch (err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  };

  if (token) {
    return <Navigate to="/yonetim/panel" />;
  }

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-logo">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.325 4.317c.83-1.179 2.081-1.779 2.081-1.779s1.898.621 2.075 1.771c.176-.155.417-.244.666-.244s.49.089.666.244c.177-.15 2.075-1.771 2.075-1.771s-.897-1.658-2.319-1.78c-1.445-.123-2.653.536-2.653.536s1.601-.536 2.805-.439c1.203.097 2.612.707 2.612.707s-1.104 1.213-2.318 1.375c-1.935.259-3.533-.488-3.533-.488s1.867-1.58 3.705-1.64c1.838-.059 3.563.451 3.563.451s-.457 1.915-1.784 3.264c-.886.902-1.766 1.61-1.766 1.61s-.134.188-.283.353c-.313.346-.752.573-1.235.573H9.065c-.483 0-.922-.227-1.235-.573-.149-.165-.283-.353-.283-.353s-.88-.708-1.766-1.61c-1.327-1.349-1.784-3.264-1.784-3.264s2.725-.51 3.563-.451c1.838.06 3.705 1.64 3.705 1.64s-1.598.747-3.533.488c-1.214-.162-2.318-1.375-2.318-1.375s1.409-.6 2.612-.707c1.203-.097 2.805.439 2.805.439s-1.104 1.213-2.653-.536c-1.422-.122-2.319 1.78-2.319 1.78s-.897-1.658-2.081 1.779c-1.184.6-2.075 1.771-2.075 1.771s-.49-.089-.666.244c-.177.15-2.075 1.771-2.075 1.771s-.897-1.658-2.319-1.78" />
          </svg>
        </div>
        <h1>Admin Girişi</h1>
        <p>Sadece yetkili adminler erişebilir</p>

        <form onSubmit={handleSubmit}>
          {error && <div className="error-msg">{error}</div>}
          
          <div className="form-group">
            <label>Kullanıcı Adı</label>
            <input type="text" value={username} onChange={e => setUsername(e.target.value)} placeholder="admin" required />
          </div>
          
          <div className="form-group">
            <label>Şifre</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)} placeholder="admin" required />
          </div>
          
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
          </button>
        </form>

        <a href="/" className="back-link">CRM'ye geri dön</a>
      </div>

      <style>{`
        .admin-login-page { min-height: 100vh; display: flex; align-items: center; justify-content: center; background: #000000; background-image: linear-gradient(rgba(var(--login-accent-light-rgb),0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(var(--login-accent-light-rgb),0.03) 1px, transparent 1px); background-size: 50px 50px; }
        .admin-login-container { background: rgba(17,17,24,0.9); border: 1px solid rgba(255,255,255,0.08); backdrop-filter: blur(40px); padding: 40px; border-radius: 20px; width: 100%; max-width: 400px; text-align: center; box-shadow: 0 24px 48px rgba(0,0,0,0.6), 0 0 80px rgba(var(--login-accent-light-rgb),0.08); }
        .admin-logo { width: 64px; height: 64px; background: linear-gradient(135deg, var(--login-accent-light), var(--login-accent)); border-radius: 16px; display: flex; align-items: center; justify-content: center; margin: 0 auto 20px; box-shadow: 0 0 24px rgba(var(--login-accent-light-rgb),0.4); }
        .admin-logo svg { width: 32px; height: 32px; color: white; }
        .admin-login-container h1 { margin: 0 0 8px; color: #FFFFFF; font-size: 24px; }
        .admin-login-container p { color: #9CA3AF; margin: 0 0 24px; font-size: 14px; }
        .form-group { margin-bottom: 16px; text-align: left; }
        .form-group label { display: block; margin-bottom: 6px; font-weight: 500; color: #E5E7EB; font-size: 14px; }
        .form-group input { width: 100%; padding: 12px; border: 1px solid rgba(255,255,255,0.08); border-radius: 10px; font-size: 15px; background: rgba(26,26,36,0.8); color: #FFFFFF; }
        .form-group input:focus { outline: none; border-color: var(--login-accent-light); box-shadow: 0 0 0 3px rgba(var(--login-accent-light-rgb),0.12); }
        .error-msg { background: rgba(239,68,68,0.1); color: #FCA5A5; border: 1px solid rgba(239,68,68,0.2); padding: 12px; border-radius: 10px; margin-bottom: 16px; font-size: 14px; }
        .btn-primary { width: 100%; padding: 14px; background: linear-gradient(135deg, var(--login-accent-light), var(--login-accent)); color: white; border: none; border-radius: 12px; font-weight: 600; cursor: pointer; font-size: 15px; box-shadow: 0 4px 16px rgba(var(--login-accent-light-rgb),0.3); transition: all 0.3s ease; }
        .btn-primary:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(var(--login-accent-light-rgb),0.4); }
        .btn-primary:disabled { opacity: 0.7; transform: none; }
        .back-link { display: block; margin-top: 20px; color: var(--login-accent-lighter); text-decoration: none; font-size: 14px; }
      `}</style>
    </div>
  );
}

export default AdminLogin;
